// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ntXiLQMcuejXvB {
  display: flex;
}
.X8GK6hWBo9CCXL {
  display: flex;
  align-items: center;
  margin: 16px;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  gap: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planner": `ntXiLQMcuejXvB`,
	"header": `X8GK6hWBo9CCXL`
};
export default ___CSS_LOADER_EXPORT___;
